function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4 0.5H1.5a1 1 0 0 0-1 1V4M12 0.5h2.5a1 1 0 0 1 1 1V4M4 15.5H1.5a1 1 0 0 1-1-1V12M12 15.5h2.5a1 1 0 0 0 1-1V12",
  stroke: "currentColor",
  strokeLinecap: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 5,
  r: 2.25,
  fill: "currentColor"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M4 12.5v-1.2A2.3 2.3 0 0 1 6.3 9h3.4a2.3 2.3 0 0 1 2.3 2.3v1.2a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5Z",
  fill: "currentColor"
});
function SvgIdv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Identity verification status") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdv);
export default __webpack_public_path__ + "static/media/idv.6ce7549da0fb469f6505c71d2b5bbc41.svg";
export { ForwardRef as ReactComponent };